import script from "./IntegrationsWrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./IntegrationsWrapper.vue?vue&type=script&lang=ts&setup=true"

import "./IntegrationsWrapper.vue?vue&type=style&index=0&id=15cb4720&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15cb4720"]])

export default __exports__